<template>
    <div class="orderDetailWrap">
        <div class="orderDetailHeader">
            <img @click="goBack" src="../assets/back.png" alt="">
            确认订单
        </div>
        <div class="orderDetailCont">
            <div class="orderDetailContBg">
                <div class="orderDetailContBgHead">
                    <img :src="dataArr.picUrl" alt="">
                    <div>
                        <h2>{{dataArr.name}}{{dataArr.name}}</h2>
                        <p>件数 {{dataArr.num}}</p>
                        <span>￥{{(dataArr.price/100).toFixed(2)}}元</span>
                    </div>
                </div>
            </div>
            <div class="orderDetailContBg">
                <ul class="orderDetailContBgCon">
                    <li>
                        <span>订单号</span>
                        <span>{{orderNoNew}}</span>
                    </li>
                    <li>
                        <span>订单时间</span>
                        <span>{{creatTime}}</span>
                    </li>
                    <li>
                        <span>购买数量</span>
                        <span>{{dataArr.num}}</span>
                    </li>
                    <li>
                        <span>尊享优惠</span>
                        <span>￥{{(dataArr.price/100-dataArr.salerPrice/100).toFixed(2)}}元</span>
                    </li>
                </ul>
            </div>
        </div>
        <div @click="goZf" class="orderDetailFooter">支付价格￥{{(priceNew/100).toFixed(2)}}</div>
        <div class="TC"></div>
        <div v-show="disOrderDetailWrap" class="orderDetailWrapBG">
            <div class="orderDetailWrapDig">
                <h2>提示</h2>
                <p>请执行以下操作</p>
                <div>
                    <span @click="gomyCard">已支付</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import common from '@/util/common';
export default {
    data() {
        return {
            orderNo: '',
            dataArr: {},
            priceNew: '',
            orderNoNew: '',
            creatTime: '',
            disOrderDetailWrap: false,
            token: '',
            price: '',
            payStatus: null,
            type: '',
            codeInfo: ''
        }
    },
    computed: {
        priceView () {
            return (this.price/100).toFixed(2)
        }
    },
    created() {
    },
    mounted() {
        var newUrl = window.location.href
        var url1 = newUrl.split('?')[1]
        var url2 = url1.split('&')[0]
        // this.orderNo = this.$store.state.orderNo
        // alert(this.orderNo)
        // this.type = this.$store.state.type
        // this.token = this.$store.state.token
        // this.$cookies.get('userInfo')
        var userInfo =JSON.parse(this.$cookies.get('userInfo')).split('&')
        // var userInfo =JSON.parse(localStorage.getItem('userInfo')).split('&')
        this.orderNo = userInfo[0].split('=')[1]
        this.token = userInfo[1].split('=')[1]
        this.type = userInfo[2].split('=')[1]
        this.codeInfo = url2.split('=')[1]
        this.init()
    },
    methods: {
        //页面初始得到数据
        init() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sdorder/getOrderInfoByOrderNo?orderNo='+ this.orderNo,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                this.payStatus = res.data.result.payStatus
                if(this.payStatus == 1) {
                    this.$router.push('/myCard?token=' + this.token)
                }
                this.priceNew = res.data.result.amount
                this.orderNoNew = res.data.result.orderNo
                this.creatTime = res.data.result.creatTime
                this.dataArr = res.data.result.itemInfo
                this.price = this.dataArr.price
            }).catch(e => {
                console.log(e);
            });
        },
        //返回
        goBack() {
            history.go(-1)
        },
        //去支付
        goZf() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/pay/order',
                async: false,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token,
                },
                data: {
                    'orderNo': this.orderNo,
                    'channel': this.type,
                    'code': this.codeInfo
                }
            }).then(res => {
                if(res.data.state == 0) {
                    if(this.type == 1) {
                        this.disOrderDetailWrap = true
                        $(".TC").append(res.data.result)
                    } 
                    if(this.type == 2) {
                        var dataResult = JSON.parse(res.data.result)
                        this.disOrderDetailWrap = true
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": dataResult.appId,     //公众号名称，由商户传入     
                                "timeStamp": dataResult.timeStamp,         //时间戳，自1970年以来的秒数     
                                "nonceStr": dataResult.nonceStr, //随机串     
                                "package": dataResult.package,     
                                "signType": dataResult.signType,         //微信签名方式：     
                                "paySign": dataResult.paySign //微信签名 
                            },
                            function(res){
                                // if(res.data.err_msg == "get_brand_wcpay_request:ok" ){
                                // // 使用以上方式判断前端返回,微信团队郑重提示：
                                // //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                // } 
                        }); 
                    }
                }
            }).catch(e => {
                console.log(e);
            });
        },
        // //微信支付
        // weixinZF() {

        // },
        //去我的卡片页
        gomyCard() {
            this.$router.push('/myCard?token=' + this.token)
        },
    }
}
</script>
<style lang="sass" scoped>
.orderDetailWrap
    width: 100%;
    height: 100vh;
    display: flex;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #F2F2F2;
    position: relative;
    .orderDetailWrapBG
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.5);
        .orderDetailWrapDig
            width: 2rem;
            background: #fff;
            height: auto;
            border-radius: 0.1rem;
            overflow: hidden;
            position: absolute;
            top: 2rem;
            left: 50%;
            transform: translate(-50%,0);
            h2
                width: 100%;
                text-align: center;
                line-height: 0.35rem;
                font-size: 0.15rem;
                color: #333;
            p
                width: 100%;
                height: 0.3rem;
                text-align: center;
                line-height: 0.3rem;
                font-size: 0.13rem;
                color: #999;
            div
                width: 100%;
                height: 0.4rem;
                span
                    line-height: 0.4rem;
                    display: block;
                    text-align: center;
                    border-top: 1px solid #ccc;  
    .orderDetailHeader
        width: 100%;
        height: 0.4rem;
        background: #fff;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.15rem;
        position: relative;
        border-bottom: 1px solid #eee;
        img
            width: 0.2rem;
            height: 0.2rem;
            position: absolute;
            top: 50%;
            left: 0.1rem;
            transform: translate(0, -50%);
    .orderDetailCont
        flex: 1;
        width: 100%;
        overflow: auto;
        .orderDetailContBg
            width: 95%;
            height: auto;
            margin: 0 auto;
            background: #fff;
            border-radius: 0.15rem;
            margin-top: 0.1rem;
            padding: 0.15rem;
            .orderDetailContBgHead
                width: 100%;
                height: auto;
                display: flex;
                overflow: hidden;
                img
                    border: 1px solid #ccc;
                    width: 0.8rem;
                    height: 0.8rem;
                    margin-right: 0.1rem;
                    flex-shrink: 0;
                    display: block;
                >div
                    flex: 1;
                    height: auto;
                    position: relative;
                    h2
                        width: 2rem;
                        font-weight: bolder;
                        font-size: 0.16rem;
                        margin-top: 0.1rem;
                        color: #333;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    p
                        font-size: 0.14rem;
                        margin-top: 0.15rem;
                    span
                        position: absolute;
                        right: 0;
                        color: #29B773;
                        bottom: 0.1rem;
            .orderDetailContBgCon
                width: 100%;
                height: auto;
                padding-left: 0.15rem;
                padding-right: 0.15rem;
                border-radius: 0.15rem;
                background: #fff;
                li
                    width: 100%;
                    height: 0.3rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span
                        color: #666;
                    span:nth-child(1)
                        width: 0.8rem;
    .orderDetailFooter
        width: 100%;
        height: 0.5rem;
        background: #29B773;
        color: #333;
        font-weight: bolder;
        line-height: 0.5rem;
        text-align: center;
        font-size: 0.18rem;
        s
            font-size: 0.13rem;
</style>


// WEBPACK FOOTER //
// src/page/orderDetail.vue